import { QueryObserverOptions, useQuery } from '@tanstack/react-query'
import { useAuth } from '../auth/useAuth'
import { ItemsService } from '../../lib/api/items.services'
import { GetInfoBoxResponseData } from '../../lib/api/types/item.interfaces'

// user items (for dashboard infobox)
export const useInfoBoxItems = (
	data: {
		showInbox?: boolean
		showNotes?: boolean
		showTodos?: boolean
	},
	options?: Partial<QueryObserverOptions<GetInfoBoxResponseData>>
) => {
	const { isAuthenticated } = useAuth()
	const { showInbox, showNotes, showTodos } = data

	return useQuery({
		queryKey: ['infobox-items', showInbox, showNotes, showTodos],
		queryFn: () =>
			ItemsService.getInfoBoxItems({ showInbox,
				showNotes,
				showTodos,
			}),
		enabled: isAuthenticated && Boolean((showInbox || showNotes || showTodos)),
		staleTime: 5 * 1000,
		gcTime: 5 * 1000,
		refetchOnWindowFocus: false,
		refetchOnMount: true,
		...options,
	})
}
